<template>
  <div class="box safe-distance-top-header-two">
    <Header pageTitle="会议稿件" />
    <div v-if="conferenceArt && conferenceArt.length" class="art-content">
      <div v-for="item in conferenceArt" :key="item.articleId" class="art-box">
        <div class="art-item">
          <div class="art-item-label">稿件编号：</div>
          <div class="art-item-value">{{ item.manuscriptNo || "--" }}</div>
        </div>
        <div class="art-item">
          <div class="art-item-label">投稿期刊：</div>
          <div class="art-item-value">{{ item.perName || "--" }}</div>
        </div>
        <div class="art-item">
          <div class="art-item-label">投稿时间：</div>
          <div class="art-item-value">{{ item.submitTime || "--" }}</div>
        </div>
        <div class="art-item">
          <div class="art-item-label">稿件名称：</div>
          <div class="art-item-value">{{ item.title || "--" }}</div>
        </div>
        <div class="art-item">
          <div class="art-item-label">投稿作者：</div>
          <div class="art-item-value">{{ item.submitUser || "--" }}</div>
        </div>
        <div class="art-item">
          <div class="art-item-label">稿件作者：</div>
          <div class="art-item-value">{{ item.authors || "--" }}</div>
        </div>
        <div class="art-item">
          <div class="art-item-label">当前节点：</div>
          <div class="art-item-value">{{ item.nodeName || "--" }}</div>
        </div>
        <div class="art-item">
          <div class="art-item-label">节点状态：</div>
          <div class="art-item-value">{{ item.auditStatusName || "--" }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header";
export default {
  name: "meeting-box",
  components: {
    Header,
  },
  data() {
    return {
      conferenceArt: [],
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      const currentMeetingInfo = sessionStorage.getItem("currentMeetingInfo");
      let obj = {};
      if (currentMeetingInfo) {
        obj = JSON.parse(currentMeetingInfo);
        this.conferenceArt = obj.manuscripts || [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100vh;
  overflow: auto;
  background-color: #f5f5f5;
  .art-content {
    padding: 12px;
    .art-title {
      font-weight: bold;
      margin-bottom: 10px;
    }
    .art-box {
      background: #fff;
      border-radius: 8px;
      padding: 10px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      .art-item {
        display: flex;
        .art-item-label {
          width: 100px;
        }
        .art-item-value {
          flex: 1;
          word-break: break-all;
        }
      }
    }
  }
}
</style>
